<template>
  <div v-on-clickaway="away" class="role-menu-wrap">
    <v-btn flat type="submit" color="primary" @click="toggle()">
      <v-icon>supervisor_account</v-icon>
    </v-btn>
    <v-list raised class="role-list" v-if="isActive">
      <v-list-tile
        v-bind:class="{active: item === activeCognitoGroup}"
        v-for="item in allowedCognitoGroups"
        :key="item"
        @click="switchRole(item)"
      >
        <v-list-tile-title v-text="item">{item}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </div>
</template>
<script>
// import TransactionService from '../services/TransactionsService'
// import SubscriptionsService from '../services/SubscriptionsService'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  name: 'RoleGroup',
  data: () => ({
    isActive: false
  }),
  methods: {
    away: function () {
      this.isActive = false
    },
    toggle: function () {
      this.isActive = !this.isActive
    },
    async switchRole (group) {
      this.$store.commit('setActiveCognitoGroup', group)
      this.isActive = false
    }
  },

  computed: {
    allowedCognitoGroups: function () {
      return this.$store.getters.allowedCognitoGroups
    },
    activeCognitoGroup: function () {
      return this.$store.getters.getActiveCognitoGroup
    }
  }
}
</script>
<style scoped>
  .role-menu-wrap {
    height: 100%;
  }
  .role-list {
    position: absolute;
    box-shadow: 1px 5px 10px #8c8c8c;

  }
  .active {
    color: #1a76d2;
  }
</style>



// WEBPACK FOOTER //
// src/components/RoleGroup.vue